import { createUseStyles } from 'react-jss'

export default createUseStyles({
  root: {
    display: 'flex',
    gap: '6px',
  },
  title: {
    marginBottom: '2px',
  },
})
